var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "efdd52fa-f990-4b63-b36f-0aac4ca61143",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a5c8264f-7b64-4d91-8a3a-d3eb55f91741",
    d: "M64,17.25A46.75,46.75,0,1,0,110.75,64,46.8,46.8,0,0,0,64,17.25Zm0,90.5A43.75,43.75,0,1,1,107.75,64,43.8,43.8,0,0,1,64,107.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a5c8264f-7b64-4d91-8a3a-d3eb55f91741",
    d: "M68.59,64a4.56,4.56,0,0,0-3.09-4.32V26.85h-3V59.68A4.58,4.58,0,0,0,64,68.59a4.63,4.63,0,0,0,2-.47L80.73,82.85l2.12-2.12L68.12,66A4.63,4.63,0,0,0,68.59,64Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountdown);
export default __webpack_public_path__ + "static/media/countdown.6474656b8225f2161bf28436707a0875.svg";
export { ForwardRef as ReactComponent };